import { Button } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React, { useEffect, useState } from 'react';
import { Check, X } from 'tabler-icons-react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { EnableDisableButtonData } from '../../type/button.types';
import { ErrorResponse } from '../../type/error-response.types';

interface Props {
  isChecked: number[];
  data: EnableDisableButtonData[] | undefined;

  setRefreshTable: React.Dispatch<React.SetStateAction<boolean>>;
}
function EnableButton(props: Props) {
  const { isChecked, data, setRefreshTable } = props;
  const [disableEnable, setDisableEnable] = useState(true);
  const [loadingEnable, setLoadingEnable] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    setDisableEnable(false);

    if (data === undefined) {
      setDisableEnable(true);
      return;
    }

    if (isChecked.length === 0) {
      setDisableEnable(true);
    } else if (isChecked.length > 0) {
      data.forEach((user) => {
        if (isChecked.includes(user.entityId)) {
          if (user.isActive) {
            setDisableEnable(true);
          }
        }
      });
    }
  }, [isChecked, data]);

  const handleEnable = async () => {
    if (data?.length === 0) {
      return;
    }
    setLoadingEnable(true);
    try {
      await axiosPrivate.post('/web/entities/enable', {
        entityIds: isChecked,
        entityType: data![0].entityType,
        newActiveStatus: true,
      });
      showNotification({
        id: 'successfully-enabled-entity',
        message: 'Successfully enabled selected account/s',
        icon: <Check size={16} />,
        color: 'teal',
        autoClose: 6000,
      });

      setRefreshTable((prev) => {
        return !prev;
      });
    } catch (err: any) {
      const error: ErrorResponse = err.response?.data;
      showNotification({
        id: 'failed-to-enable-entity',
        message: error.error || 'An Unexpected Error Occurred',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000,
      });
    } finally {
      setLoadingEnable(false);
    }
  };

  return (
    <>
      <Button
        disabled={disableEnable}
        onClick={handleEnable}
        loading={loadingEnable}
      >
        ENABLE
      </Button>
    </>
  );
}

export default EnableButton;
